// Timing our own code (docs/ARCHITECTURE.md §2.9): the 10k test turns this on (window.nowishTiming = true) and reads
// the "nowish:" User Timing measures, so its budget is on what our code does, apart from the browser's drawing
// (which, without a GPU, is most of every frame). Off, it costs one property read.
declare global { interface Window { nowishTiming?: boolean } }

export function timed<T>(name: string, fn: () => T): T {
  if (typeof window === "undefined" || !window.nowishTiming) return fn();
  const start = performance.now();
  try { return fn(); } finally { performance.measure(`nowish:${name}`, { start, end: performance.now() }); }
}
